module.exports = __webpack_public_path__ + "static/media/Sverige.277eedfb.svg";